import { MergeTag } from 'ui/icons/action/MergeTag';
import styled from 'styled-components';
import { useState } from 'react';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { BaseToolbarButton } from './BaseToolbarButton';
import { useEditorContext } from '../contexts/editor';
import { MergeTagsMenu } from '../mergeTagsMenu';
import { serializeMergeTag } from '../utils/serializeMergeTag';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ToggleMergeTagMenuButton = () => {
  const { t } = useTranslation();
  const { editor } = useEditorContext();
  const [isOpen, setIsOpen] = useState(false);
  const showMenu = () => setIsOpen(true);
  const hideMenu = () => setIsOpen(false);

  const handleSelect = (fieldName: string) => {
    if (editor) editor.insertContent(serializeMergeTag(fieldName));
    hideMenu();
  };

  return (
    <Wrapper>
      <BaseToolbarButton
        isSelected={false}
        onClick={showMenu}
        tooltip={t('contentPicker.textEditor.mergeTag')}
        data-test="merge-tag-button"
      >
        <MergeTag isColorInherited />
      </BaseToolbarButton>
      {isOpen && <MergeTagsMenu onSelect={handleSelect} onClose={hideMenu} />}
    </Wrapper>
  );
};
